import { StoreState } from "~/redux/reducers";

export const selectFlagsReadyClientId = (state: StoreState) =>
  state.app.ready.flags.clientId;
export const selectFlagsReadyFcId = (state: StoreState) =>
  state.app.ready.flags.fcId;
export const selectAuthHeaderReady = (state: StoreState) =>
  state.app.ready.authHeader;
export const selectClientConfigReady = (state: StoreState) =>
  state.app.ready.clientConfig;
export const selectSignalRReadyMain = (state: StoreState) =>
  state.app.ready.signalr.main;
export const selectSignalRReadyAndon = (state: StoreState) =>
  state.app.ready.signalr.andon;
export const selectServerConfig = (state: StoreState) => state.app.clientConfig;
export const selectSignalREnabled = (state: StoreState) =>
  state.app.signalREnabled;
